
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"48","cy":"48","r":"46","stroke":"#B5D4F4","stroke-width":"1.5","stroke-dasharray":"3 6"}}),_c('circle',{attrs:{"cx":"48","cy":"48","r":"30","fill":"#E6F1FB"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47.93 32.5c8.523 0 15.431 6.908 15.431 15.43 0 8.523-6.908 15.431-15.43 15.431-8.523 0-15.431-6.908-15.431-15.43 0-8.523 6.908-15.431 15.43-15.431zm7.54 22.995h-4.118v-1.837c-1.15 1.4-2.873 2.273-5.203 2.273-4.245 0-7.757-3.58-7.757-8.218s3.512-7.782 7.757-7.782h9.321v15.564zm-8.554-12.172c-2.522 0-4.406 1.775-4.406 4.39 0 2.615 1.884 4.389 4.406 4.389 2.553 0 4.436-1.774 4.436-4.39 0-2.614-1.883-4.389-4.436-4.389z","fill":"#0059CD"}}),_c('circle',{attrs:{"cx":"82","cy":"20","r":"5","fill":"#64BCFF"}}),_c('circle',{attrs:{"cx":"16","cy":"74","r":"3.5","fill":"#A4D8FF"}})])
          )
        }
      }
    